export function SquidGameView({ winners, losers }) {
  const w = winners?.length || 0;
  const l = losers?.length || 0;
  if (!w && !l) return null;
  return (
    <section className="border-t border-white/10 px-3 py-3 bg-pink-900/10" data-testid="squid-game-view">
      <h4 className="text-[11px] uppercase tracking-wider font-semibold text-pink-300 mb-2">
        Squid Game promo
      </h4>
      <div className="flex gap-6 text-[12px] text-slate-300">
        <div>
          <span className="text-slate-500">Winners:</span> {w}
        </div>
        <div>
          <span className="text-slate-500">Losers:</span> {l}
        </div>
      </div>
    </section>
  );
}
